import React, { Fragment, useState } from 'react';
import { Polygon } from 'react-leaflet';
import { flatten, chain } from 'lodash';
import { areaHighLightColor } from '../../constants/colors';

export default function RenderOLSTransitionalSurface({
  OLSTransitionalSurfaceList,
  selectedOls,
  getOLSColors
}) {
  const [selectedOverE, setSelectedOverE] = useState(null);
  const olsColor = getOLSColors();
  const visibleOLSTransitionalSurfaceList =
    chain(OLSTransitionalSurfaceList)
      .filter((tslObj) => {
        const name = `${tslObj.type}_${tslObj.rwy_designator}`;
        return selectedOls.includes(`${name}__${olsColor[name]}`);
      })
      .value();

  const handlePolygonOver = (e, element) => {
    e.target.bringToFront();
    setSelectedOverE(element);
  };

  const handlePolygonOut = () => {
    setSelectedOverE(null);
  };

  return (
   <Fragment>
     {
        visibleOLSTransitionalSurfaceList.map((olsTsl) => {
          const tslCoordinates = olsTsl.coordinates.coordinates;
          const name = `${olsTsl.type}_${olsTsl.rwy_designator}`;
          const tslCoordinateMap = flatten(tslCoordinates).map((tslCoords) => {
            return tslCoords.map((tsl) => {
              return {
                lng: tsl[0],
                lat: tsl[1]
              };
            });
          });

          return tslCoordinateMap.map((tslPolygonPath, i) => (
            <Polygon
              key={i}
              pane="tilePane"
              positions={tslPolygonPath}
              pathOptions={{
                fillColor: olsColor[name],
                color: selectedOverE?.rwy_designator === olsTsl.rwy_designator ? areaHighLightColor : olsColor[name],
                weight: selectedOverE?.rwy_designator === olsTsl.rwy_designator ? 3 : 2,
              }}
              eventHandlers={{
                mouseover: (e) => handlePolygonOver(e, olsTsl),
                mouseout: () => handlePolygonOut()
              }}
            />
          ));
        })
     }
   </Fragment> 
  )
}